var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg53(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12 25.0609 12.4214 26.0783 13.1716 26.8284C13.9217 27.5786 14.9391 28 16 28C17.0609 28 18.0783 27.5786 18.8284 26.8284C19.5786 26.0783 20 25.0609 20 24",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00009 13C7.00009 10.6131 7.9483 8.32387 9.63613 6.63604C11.324 4.94821 13.6131 4 16.0001 4C18.387 4 20.6762 4.94821 22.364 6.63604C24.0519 8.32387 25.0001 10.6131 25.0001 13C25.0001 17.4775 26.0376 21.075 26.8626 22.5C26.9502 22.6518 26.9964 22.8239 26.9966 22.9991C26.9967 23.1744 26.9508 23.3466 26.8635 23.4985C26.7761 23.6504 26.6504 23.7767 26.4989 23.8647C26.3473 23.9527 26.1753 23.9994 26.0001 24H6.00009C5.82506 23.9989 5.65338 23.952 5.5022 23.8638C5.35101 23.7756 5.22563 23.6492 5.13857 23.4974C5.05152 23.3456 5.00584 23.1735 5.0061 22.9985C5.00637 22.8235 5.05257 22.6516 5.14009 22.5C5.96384 21.075 7.00009 17.4763 7.00009 13Z",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg53);
export default __webpack_public_path__ + "static/media/svg53.7faa2eb612cfb83c270136f07217b8dd.svg";
export { ForwardRef as ReactComponent };